var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIconFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 38,
    viewBox: "0 0 27 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09007 13.6497C5.433 8.68208 7.95127 5.64142 11.2599 3.02608C17.013 -1.51166 20.349 0.0317161 23.3294 1.41354C27.7932 3.48371 26.8738 5.01756 24.7944 9.46371C22.7078 13.8998 21.6844 15.3185 17.2228 13.2484C12.7572 11.1755 14.3372 8.0539 14.3372 8.0539L6.01055 25.8124C6.01055 25.8124 7.75936 23.0214 12.2255 25.0915C16.6867 27.1617 15.9912 28.6404 13.9141 33.0761C11.8278 37.5218 11.1347 39.0052 6.66902 36.9345C3.69102 35.5527 0.391722 33.7967 0.187848 26.4954C0.0724596 22.2907 0.765597 18.6311 3.0898 13.6492L3.09007 13.6497Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconFooter);
export default __webpack_public_path__ + "static/media/phone-icon-footer.390fe6afdc8c0c9e72701c17fbacecb4.svg";
export { ForwardRef as ReactComponent };